
<template>
  <div>
    <div :class="hidedata?'l-d l-d-l':'l-d'">
      <div>
        <i @click="hideLeft" v-if="!hidedata" class="el-icon-d-arrow-left rg"></i>
        <i @click="hideLeft" v-else class="el-icon-d-arrow-right rg"></i>
        <div class="l-t">
          {{isShowHotCity?hotZoneAreas[0].cityName+'道路排行 TOP30':'全国道路排行TOP150'}}
          <div>
            <img width="16" src="../../../assets/images/year.png" />年运营
            <img class="img" width="16" src="../../../assets/images/day.png" />日运营
          </div>
        </div>
        <div class="l-btn" v-if="!isShowHotCity">
          <el-button
            v-for="(i,k) in btnData"
            :key="k"
            :class="btnIndex==i.name?'a-btn':''"
            @click="getData(k,i.name)"
            size="small"
          >{{i.name}}</el-button>
        </div>
        <div class="l-cont l-cont-ll">
          <ul class="lanimate">
            <div
              v-for="(i,k) in listData"
              :key="k"
              :class="i.isShow?'a':k==activeIndex?'aClick':''"
              @mouseover="overFun(k)"
              @click="clickFun(i.id)"
              @mouseout="outFun"
            >
              <h5 v-html="i.highSpeedName"></h5>
              <div class="lb">
                <div :style="{width: i.percentage+'%',background:i.color}" class="gr"></div>
              </div>
              <div class="l-bot">
                <img width="16" src="../../../assets/images/year.png" />
                <span>{{i.yearOperate}}</span>
                <div>
                  <img width="16" src="../../../assets/images/day.png" />
                  <span>{{i.dayOperate}}</span>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div class="more">
          <div class="m" @click="moreData">more</div>
        </div>
      </div>
    </div>
    <!-- 颜色 -->
    <colorSign :hidedata="hidedata" />
  </div>
</template>
 
<script>
import colorSign from '../mapComponents/colorSign.vue'
import { setTimeout } from 'timers'
export default {
  components: {
    colorSign
  },
  data() {
    return {
      btnData: [{ name: '全部' },{ name: '高速' }, { name: '国道' }, { name: '省道' }],
      activeIndex: '-1',
      listData: [],
      hidedata: false,
      switchTime: null
    }
  },
  props: {
    hotZoneAreas: {
      type: Array,
      default: () => {
        return []
      }
    },
    leftData: {
      type: Array,
      default: () => {
        return []
      }
    },
    leftIndex: Number,
    btnIndex: String,
    isShowHotCity: Boolean
  },

  watch: {
    leftIndex(val, oldVal) {
      if (val !== null) {
        this.clickFun(val)
      }
    },
    leftData(val, oldVal) {
      if (val !== null) {
        this.listData = this.leftData
      }
    }
  },
  computed: {},
  created() {
    this.listData = this.leftData
  },
  mounted() {},
  methods: {
    changeTop(k){
        document.querySelector('.l-cont-ll').scrollTop = 110*k
    },
    // 监听滚动
    setTimer() {
      if (this.listData.length > 0 && document.querySelector('.l-cont-ll')!=null) {
        var h = document.querySelector('.lanimate').offsetHeight
        var t = document.querySelector('.l-cont-ll').scrollTop
        this.switchTime = setInterval(function() {
          if (h - t <= 0) {
            t = 0
          } else {
            t = t + 0.1
          }
          document.querySelector('.l-cont-ll').scrollTop = t
        }, 1)
      }
    },
    hideLeft() {
      this.hidedata = !this.hidedata
      this.$emit('isShowList', this.hidedata)
    },
    getData(k, name) {
      this.$emit('initData', name, true)
    },
    // 鼠标放上去事件
    overFun(i) {
      this.activeIndex = i
    },
    clickFun(id) {
      var listData = this.listData
      this.activeIndex = '-1'
      this.$emit('changeLeftIndex', id)
    },
    outFun() {
      this.activeIndex = -1
    },
    moreData() {
      this.$parent.topRoadAll = true
    }
  }
}
</script>

<style scoped>
.m {
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  opacity: 0.6;
  width: 98%;
  margin-left: 1%;
  background-image: linear-gradient(-90deg, #2daaff 2%, #5a74fc 98%);
  border-radius: 2px;
}

.m:hover {
  opacity: 1;
  cursor: pointer;
}

.more {
  width: 100%;
  position: absolute;
  bottom: 0px;
  height: 30px;
  padding-top: 10px;
  z-index: 900;
  background: #2b304c;
}
</style>